import { StepAction } from './stepAction';
import { KEY_MAP } from '../utils/stepActionUtils';
import type { KeyboardShortcutStep } from 'clickim/src/common/models/keyboardShortcutStep';

export class KeyboardShortcutStepAction extends StepAction<KeyboardShortcutStep> {
    override async performAction() {
        const isMac = this.context.config.os.startsWith('Mac');

        if ((isMac && !this.step.keys?.mac) || (!isMac && !this.step.keys?.windows)) {
            return undefined;
        }

        const keys = [];
        const shortcutKeys = isMac ? this.step.keys!.mac! : this.step.keys!.windows!;

        if (shortcutKeys.altKey) {
            keys.push('\uE052');
        }

        if (shortcutKeys.ctrlKey) {
            keys.push('\uE051');
        }

        if (shortcutKeys.metaKey) {
            keys.push('\uE03D');
        }

        if (shortcutKeys.shiftKey) {
            keys.push('\uE050');
        }

        const keyCode = shortcutKeys.keyCode;

        // TODO keyCode is deprecated. https://tricentis.atlassian.net/browse/TES-19019
        if (keyCode >= 32 && keyCode <= 127) {
            keys.push(shortcutKeys.key);
        } else if (KEY_MAP[keyCode as keyof typeof KEY_MAP]) {
            keys.push(KEY_MAP[keyCode as keyof typeof KEY_MAP]);
        } else {
            throw new Error(`Invalid key with keyCode ${keyCode}.`);
        }

        return await this.driver.sendKeyboardShortcut(keys);
    }
}
